module.exports = __webpack_public_path__ + "img/yxlogo_black2.f6155889.png";